//@flow
import React from 'react';
import StockRemindersActions from '../../Actions/stockReminders';
import MediaQuery from 'react-responsive';
import Query from '../../Utils/query';
import { Link } from 'react-router';
import OutOfStockEmailForm from './OutOfStockEmailForm.react';
import CustomerModel from '../../Stores/Customer/customerModel';

type Props = {
  reminderSet:?boolean,
  sku:string,
  email:?string,
  customer:?CustomerModel,
  comingSoon:boolean,
};

type State = {
  showForm:boolean,
};

export default class OutOfStockReminderProduct extends React.Component<Props, State> {
  state = { showForm: false };

  showForm = () => {
    this.setState({ showForm: true });
  };

  setReminder = () => {
    if (!this.props.email) return this.showForm();
    StockRemindersActions.setStockReminder(this.props.email, this.props.sku);
  };

  getForm() {
    //show different text depending on size
    if (this.state.showForm) {
      const buttonTextSm = this.props.comingSoon ? 'Sign up' : 'Notify me';
      const buttonText = this.props.comingSoon ? 'Get early access' :
        'Get restock alert';

      return (
        <div className="out-of-stock-email-form">
          <MediaQuery query={Query.toEm({ min: 441 })}>
            <OutOfStockEmailForm
              customer={this.props.customer}
              sku={this.props.sku}
              buttonClassName="cta-secondary-color"
              buttonText={buttonText}
            />
          </MediaQuery>
          <MediaQuery query={Query.toEm({ max: 440})}>
            <OutOfStockEmailForm
              customer={this.props.customer}
              sku={this.props.sku}
              buttonClassName="cta-secondary-color"
              buttonText={buttonTextSm}
            />
          </MediaQuery>
        </div>
      );
    }
  }

  getEmailText() {
    return this.props.email ? `at ${this.props.email} ` : '';
  }

  getMobileDisplay() {
    if (!this.state.showForm) {
      const text = this.props.comingSoon ? 'Get early access' : 'Get restock alert';
      return (
        <button onClick={this.setReminder} className="cta-secondary-color set-reminder-mobile">
          {text}
        </button>
      );
    }

    const formText = this.props.comingSoon ? 'Sign me up for early access!' :
      'Notify me when this item is back in stock!';
    return (
      <div className="mobile notify-me">{formText}</div>
    );
  }

  render() {
    if (this.props.reminderSet) {
      return (
        <div className="reminder-set">
          <span className="bold">{`Thanks! We'll email you ${this.getEmailText()}when it's back in stock.`}</span>
          <Link to="/products" className="shop-all link"> Shop all products</Link>
        </div>
      );
    }

    const titleText = this.props.comingSoon ? 'Sign me up ' : 'Notify me ';
    const text = this.props.comingSoon ? 'for early access!' :
      'when this item is back in stock!';

    return (
      <div className="out-of-stock-reminder product">
        <MediaQuery query={Query.toEm({ min: 441 })}>
          <div className="set-reminder-text-container md-up">
            <span onClick={this.setReminder} className="set-reminder link">{titleText}</span>
            <span>{text}</span>
          </div>
        </MediaQuery>
        <MediaQuery query={Query.toEm({ max: 440})}>
          {this.getMobileDisplay()}
        </MediaQuery>
        {this.getForm()}
      </div>
    );
  }
}
